function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.025 9.747L24.994.181a1.75 1.75 0 00-.789-.18H1.838a1.78 1.78 0 00-.796.18l11.983 9.566z",
  fill: "#7F63FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.862 1.056l-.043.051-12.403 9.92a.644.644 0 01-.774 0L.232 1.108l-.044-.05C.064 1.305 0 1.58 0 1.86v13.647a1.867 1.867 0 001.838 1.86h22.33a1.866 1.866 0 001.86-1.86V1.86a1.795 1.795 0 00-.166-.804z",
  fill: "#7F63FF"
});

function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 18",
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "4ec73c32cb1345d5e62b6f8f049c3054.svg";
export { SvgEmailIcon as ReactComponent };